var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Suggestions = function ($element) {
  this.updateSuggestions = bind(this.updateSuggestions, this);
  this.updateFree = bind(this.updateFree, this);

  this.element = $element;
  this.free = $element.find(".js-suggestion-free");
  this.suggestions = $element.find(".js-suggestion-input");
  this.thanks = $element.find(".js-thanks");

  // this.free.mask('00 000', {reverse: true});

  this.free.on("keyup", this.updateSuggestions);
  this.suggestions.on("change focus", this.updateFree);
};

/* --------------------------------------------
  Update suggestions
  @Params: data
  @Returns: none
*/
Suggestions.prototype.updateSuggestions = function (e) {
  var current = $(e.currentTarget),
    value = current.val();

  this.suggestions.not('[value="' + value + '"]').prop("checked", false);
  this.suggestions.filter('[value="' + value + '"]').prop("checked", true);

  this.updateThanks(value);
};

/* --------------------------------------------
  Update free
  @Params: data
  @Returns: none
*/
Suggestions.prototype.updateFree = function (e) {
  var current = $(e.currentTarget),
    value = current.val().replace(/^0+/, "");

  this.free.val(value);
  this.updateThanks(value);
};

Suggestions.prototype.updateThanks = function (value) {
  if (value != 0) {
    this.thanks.addClass("thanks--show");
  } else {
    this.thanks.removeClass("thanks--show");
  }
};

module.exports = Suggestions;
